"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfileNameDto = instanceOfProfileNameDto;
exports.ProfileNameDtoFromJSON = ProfileNameDtoFromJSON;
exports.ProfileNameDtoFromJSONTyped = ProfileNameDtoFromJSONTyped;
exports.ProfileNameDtoToJSON = ProfileNameDtoToJSON;
exports.ProfileNameDtoToJSONTyped = ProfileNameDtoToJSONTyped;
/**
 * Check if a given object implements the ProfileNameDto interface.
 */
function instanceOfProfileNameDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
function ProfileNameDtoFromJSON(json) {
    return ProfileNameDtoFromJSONTyped(json, false);
}
function ProfileNameDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}
function ProfileNameDtoToJSON(json) {
    return ProfileNameDtoToJSONTyped(json, false);
}
function ProfileNameDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'id': value['id'],
    };
}
//# sourceMappingURL=ProfileNameDto.js.map